<div [ngStyle]="dynamicCss" [style.background-color]="singleItem?.contentBackgroundColor"
    class="dynamic-alert-messages">
    <span [innerHtml]="singleItem?.content | sanitizeHtml: 'HTML' "> </span>
</div>